import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Lightning, User, EnvelopeSimple, Lock, SpinnerGap } from "@phosphor-icons/react";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import SEO from "@/components/SEO";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      await register(form.name, form.email, form.password);
      navigate("/account");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Registration failed");
    } finally { setBusy(false); }
  };

  return (
    <>
      <SEO title="Create Account" description="Join Ebikes&Gear for faster checkout, order tracking and exclusive offers." path="/register" />
      <div className="container-px grid min-h-[80vh] place-items-center py-12">
        <div className="w-full max-w-md rounded-[2rem] border border-border bg-card p-8 shadow-soft" data-testid="register-card">
          <span className="grid h-12 w-12 place-items-center rounded-2xl bg-primary text-primary-foreground"><Lightning size={26} weight="fill" /></span>
          <h1 className="mt-5 text-3xl font-black tracking-tight">Create your account</h1>
          <p className="mt-1 text-muted-foreground">Join 20,000+ riders across Europe.</p>

          {error && <div className="mt-5 rounded-xl bg-primary/10 px-4 py-3 text-sm text-primary" data-testid="register-error">{error}</div>}

          <form onSubmit={submit} className="mt-6 space-y-4">
            <div className="flex items-center gap-3 rounded-xl border border-border bg-background px-4 py-3">
              <User size={20} className="text-muted-foreground" />
              <input required placeholder="Full name" value={form.name} onChange={set("name")} className="flex-1 bg-transparent text-sm outline-none" data-testid="register-name" />
            </div>
            <div className="flex items-center gap-3 rounded-xl border border-border bg-background px-4 py-3">
              <EnvelopeSimple size={20} className="text-muted-foreground" />
              <input required type="email" placeholder="Email address" value={form.email} onChange={set("email")} className="flex-1 bg-transparent text-sm outline-none" data-testid="register-email" />
            </div>
            <div className="flex items-center gap-3 rounded-xl border border-border bg-background px-4 py-3">
              <Lock size={20} className="text-muted-foreground" />
              <input required type="password" minLength={6} placeholder="Password (min 6 chars)" value={form.password} onChange={set("password")} className="flex-1 bg-transparent text-sm outline-none" data-testid="register-password" />
            </div>
            <button disabled={busy} className="btn-primary w-full" data-testid="register-submit">
              {busy ? <SpinnerGap size={20} className="animate-spin" /> : "Create Account"}
            </button>
          </form>

          <p className="mt-6 text-center text-sm text-muted-foreground">
            Already have an account? <Link to="/login" className="font-semibold text-primary hover:underline">Sign in</Link>
          </p>
        </div>
      </div>
    </>
  );
}
